import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-bar-down', 'IconArrowBarDown', [
  ['path', { d: 'M12 20l0 -10', key: 'svg-0' }],
  ['path', { d: 'M12 20l4 -4', key: 'svg-1' }],
  ['path', { d: 'M12 20l-4 -4', key: 'svg-2' }],
  ['path', { d: 'M4 4l16 0', key: 'svg-3' }],
]);
